import { render, staticRenderFns } from "./carusel.vue?vue&type=template&id=07615736&scoped=true"
import script from "./carusel.vue?vue&type=script&lang=js"
export * from "./carusel.vue?vue&type=script&lang=js"
import style0 from "./carusel.vue?vue&type=style&index=0&id=07615736&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07615736",
  null
  
)

export default component.exports